(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("angular-jsoneditor", [], factory);
	else if(typeof exports === 'object')
		exports["angular-jsoneditor"] = factory();
	else
		root["angular-jsoneditor"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition